import '../styles/loader.css'; // Import your CSS file

export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader" />
    </div>
  );
};
